import { render, staticRenderFns } from "./SettlementList.vue?vue&type=template&id=ccd0fb02"
import script from "./SettlementList.vue?vue&type=script&lang=js"
export * from "./SettlementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports